import React from 'react';
import {
  Box,
  Heading,
  Table,
  Tbody,
  Tr,
  Td,
} from '@chakra-ui/react';
import { PrintEE } from './profile/printEE';
import { PrintSubstate } from './profile/printSubstate';

// const isListItemEmpty = listItem => Object.keys(listItem).length < 1;

// const isListEmpty = list => !Object.values(list).some(i => !isListItemEmpty(i));

const isStructuredEmpty = structuredFragment => {
  const { education, experience, ...rest } = structuredFragment;

  return Object.keys(rest) < 1;
};

const isEEEmpty = structuredFragment => {
  const { education, experience, adresses, trips, relatives, ...rest } =
    structuredFragment;

  return Object.keys(rest) < 1;
};

export const PrintProfile = ({ user }) => {
  const noSpouse = isStructuredEmpty(user.structured.spouse);
  const noSponsor = isStructuredEmpty(user.structured.sponsor);
  const noSponsored = isStructuredEmpty(user.structured.sponsored);
  const noEE = !Object.values(user.structured.ext).some(i => !isEEEmpty(i));
  return (
    <Box>
      <Box>
        <Heading pt={6} fontSize="lg" flex="1" textAlign="left">
          Critical
        </Heading>
        <Box>{user.critical}</Box>
        <Heading pt={6} fontSize="lg" flex="1" textAlign="left">
          Personal Information
        </Heading>
        <Table variant="simple">
          <Tbody>
            <Tr>
              <Td>
                <strong>E-mail</strong>
              </Td>
              <Td>{user.email}</Td>
            </Tr>
            <Tr>
              <Td>
                <strong>Service</strong>
              </Td>
              <Td>{user.service}</Td>
            </Tr>
            <Tr>
              <Td>
                <strong>Status</strong>
              </Td>
              <Td>{user.status}</Td>
            </Tr>
            <Tr>
              <Td>
                <strong>Secondary status</strong>
              </Td>
              <Td>{user.secondary_status}</Td>
            </Tr>
            <Tr>
              <Td>
                <strong>Consultation type</strong>
              </Td>
              <Td>{user.cons_type}</Td>
            </Tr>
            <Tr>
              <Td>
                <strong>Term</strong>
              </Td>
              <Td>{user.term}</Td>
            </Tr>
            <Tr>
              <Td>
                <strong>Phone number</strong>
              </Td>
              <Td>{user.phone_number}</Td>
            </Tr>
            <Tr>
              <Td>
                <strong>Citizenship</strong>
              </Td>
              <Td>{user.citizenship}</Td>
            </Tr>
            <Tr>
              <Td>
                <strong>Residence</strong>
              </Td>
              <Td>{user.residence}</Td>
            </Tr>
            <Tr>
              <Td>
                <strong>City</strong>
              </Td>
              <Td>{user.city}</Td>
            </Tr>
            <Tr>
              <Td>
                <strong>Birth Date</strong>
              </Td>
              <Td>{user.birth_date}</Td>
            </Tr>
            <Tr>
              <Td>
                <strong>Age</strong>
              </Td>
              <Td>{user.age}</Td>
            </Tr>
            <Tr>
              <Td>
                <strong>Marital Status</strong>
              </Td>
              <Td>{user.marital_status}</Td>
            </Tr>
            <Tr>
              <Td>
                <strong>Financial</strong>
              </Td>
              <Td>{user.financial}</Td>
            </Tr>
            <Tr>
              <Td>
                <strong>English skills</strong>
              </Td>
              <Td>{user.english_skills}</Td>
            </Tr>
            <Tr>
              <Td>
                <strong>IELTS/CELPIP</strong>
              </Td>
              <Td>{user.ielts_celpip}</Td>
            </Tr>
            <Tr>
              <Td>
                <strong>French skills</strong>
              </Td>
              <Td>{user.french_skills}</Td>
            </Tr>
            <Tr>
              <Td>
                <strong>TEF/TCN</strong>
              </Td>
              <Td>{user.tef_tcn}</Td>
            </Tr>
          </Tbody>
        </Table>
        <Heading pt={6} fontSize="lg" flex="1" textAlign="left">
          Children
        </Heading>
        <Box>{user.children}</Box>
        <Heading pt={6} fontSize="lg" flex="1" textAlign="left">
          Criminality
        </Heading>
        <Box>{user.criminality}</Box>
        <Heading pt={6} fontSize="lg" flex="1" textAlign="left">
          Health issues
        </Heading>
        <Box>{user.health_issues}</Box>
        <Heading pt={6} fontSize="lg" flex="1" textAlign="left">
          Visa refusals
        </Heading>
        <Box>{user.visa_refusals}</Box>
        <Heading pt={6} fontSize="lg" flex="1" textAlign="left">
          Trips abroad
        </Heading>
        <Box>{user.trips_abroad}</Box>
        <Heading pt={6} fontSize="lg" flex="1" textAlign="left">
          Relatives
        </Heading>
        <Box>{user.relatives}</Box>
        <Heading pt={6} fontSize="lg" flex="1" textAlign="left">
          Questions
        </Heading>
        <Box>{user.questions}</Box>
      </Box>
      <PrintEE
        education={user.structured.education}
        experience={user.structured.experience}
      />
      {!noSpouse && (
        <Box pb={6}>
          <Heading pt={6} fontSize="lg" flex="1" textAlign="left">
            Spouse
          </Heading>
          <PrintSubstate {...user.structured.spouse} />
        </Box>
      )}
      {!noSponsor && (
        <Box pb={6}>
          <Heading pt={6} fontSize="lg" flex="1" textAlign="left">
            Sponsor
          </Heading>
          <PrintSubstate {...user.structured.sponsor} />
        </Box>
      )}
      {!noSponsored && (
        <Box pb={6}>
          <Heading pt={6} fontSize="lg" flex="1" textAlign="left">
            Sponsored
          </Heading>
          <PrintSubstate {...user.structured.sponsored} />
        </Box>
      )}
      {!noEE && (
        <Box pb={6}>
          <Heading pt={6} fontSize="lg" flex="1" textAlign="left">
            Express Entry information
          </Heading>
          {Object.values(user.structured.ext).map(
            (item, i) =>
              !isEEEmpty(item) && (
                <Box pb={6}>
                  <Heading pt={4} flex="1" textAlign="left">
                    {`${item.lastName || 'Имя'} ${item.firstName || 'Имя'}`}
                  </Heading>
                  <PrintSubstate {...item} />
                </Box>
              )
          )}
        </Box>
      )}
    </Box>
  );
};
